import reducer, { addTimezone, utcToDisplayDate } from 'event-widgets/redux/modules/timezones';
import { registerTranslation } from 'nucleus-guestside-site/src/redux/modules/text';

/*
 * Creates a thunked action to load the timezone. Any language resource strings will
 * added to the necessary text resolvers.
 * @param The id of the timezone to load.
 */
export const loadTimezone = (timezoneId) =>
  async (dispatch, getState) => {
    const { accessToken, clients: { lookupClient }, text } = getState();
    const locales = [text.locale];
    const response = await lookupClient.getTimezone(accessToken, timezoneId, locales);
    const { timeZones, translations } = response;
    dispatch(addTimezone(timezoneId, timeZones[timezoneId]));
    dispatch(registerTranslation(translations[text.locale], text.locale, text.resolver.context));
  };

/**
 * Creates a thunked action to load the timezone data and register related translations for the event
 * into the redux store
 * @param timezoneId
 * @param timeZones
 * @param translations
 * @returns {Function}
 */
export const loadEventTimezoneIntoStore = (timezoneId, timeZones, translations) => {
  return (dispatch, getState) => {
    const { text } = getState();
    dispatch(addTimezone(timezoneId, timeZones[timezoneId]));
    dispatch(registerTranslation(translations[text.locale], text.locale, text.resolver.context));
  };
};

/*
 * Loads the timezone for the event.
 */
export const loadEventTimezone = () =>
  async (dispatch, getState) => {
    const { event: { timezone } } = getState();
    await dispatch(loadTimezone(timezone));
  };

// Export the reducer and any methods from base timezone reducer for ease of use.
export default reducer;
export { utcToDisplayDate };
